import rutasjson from '@/assets/utils/rutas.json'
import axiosIns from '@/libs/axios'
import axiosBase from '@/axios'

export const API_ENV_STORAGE_KEY = 'apiEnvironment'
const PROD_AXIOS_URL = rutasjson.axios
const PROD_AXIOSREP_URL = rutasjson.axiosrep
const TEST_AXIOS_URL = rutasjson.axios_test || PROD_AXIOS_URL
const TEST_AXIOSREP_URL = rutasjson.axiosrep_test || PROD_AXIOSREP_URL

export const API_ENVIRONMENTS = Object.freeze({
  prod: {
    value: 'prod',
    text: 'Producción',
  },
  test: {
    value: 'test',
    text: 'Pruebas',
  },
})

export const getApiEnvironmentOptions = () => [
  API_ENVIRONMENTS.prod,
  API_ENVIRONMENTS.test,
]

export const normalizeApiEnvironment = value => (value === API_ENVIRONMENTS.test.value ? API_ENVIRONMENTS.test.value : API_ENVIRONMENTS.prod.value)

const getApiBaseUrlByEnvironment = environment => (
  environment === API_ENVIRONMENTS.test.value
    ? TEST_AXIOS_URL
    : PROD_AXIOS_URL
)

const getApiReportBaseUrlByEnvironment = environment => (
  environment === API_ENVIRONMENTS.test.value
    ? TEST_AXIOSREP_URL
    : PROD_AXIOSREP_URL
)

export const getStoredApiEnvironment = () => {
  if (typeof window === 'undefined') return API_ENVIRONMENTS.prod.value
  return normalizeApiEnvironment(window.localStorage.getItem(API_ENV_STORAGE_KEY))
}

export const applyApiEnvironment = (environment = API_ENVIRONMENTS.prod.value) => {
  const normalizedEnvironment = normalizeApiEnvironment(environment)
  const baseURL = getApiBaseUrlByEnvironment(normalizedEnvironment)
  const reportBaseURL = getApiReportBaseUrlByEnvironment(normalizedEnvironment)

  rutasjson.axios = baseURL
  rutasjson.axiosrep = reportBaseURL
  axiosIns.defaults.baseURL = baseURL
  axiosBase.defaults.baseURL = baseURL

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(API_ENV_STORAGE_KEY, normalizedEnvironment)
  }

  return {
    environment: normalizedEnvironment,
    baseURL,
    reportBaseURL,
  }
}
